import {NgModule} from '@angular/core';
import {CalendarModule} from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import {TabViewModule} from 'primeng/tabview';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ModalModule} from 'ng2-bootstrap/modal';
import {UIHelpersModule} from './ui-helpers.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ChartModule} from 'primeng/chart';
import {PaginatorModule} from 'primeng/paginator';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TreeModule} from 'primeng/tree';
import {TreeTableModule} from 'primeng/treetable';
import {ProductFormValidator} from '../components/directives/validators/product-form-validator.directive';
import {CheckboxModule} from 'primeng/checkbox';
import {InputNumberModule} from 'primeng/inputnumber';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {MessageService} from 'primeng/api';
import {environment} from '../../environments/environment';
import {ReactiveFormsModule} from '@angular/forms';
import {EditorModule} from '@tinymce/tinymce-angular';
import {ChipsModule, FileUploadModule, InputMaskModule} from 'primeng';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {NgxViewerModule} from 'ngx-viewer';
import {FilePreviewComponent} from '../components/ui/file-preview/file-preview.component';
import {CommonModule} from '@angular/common';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http);
  let contextPath = '';
  // if (environment.production) {
    contextPath = document.getElementsByTagName('base')[0].getAttribute('href') || '/';
  // }
  return new TranslateHttpLoader(http, `${contextPath}assets/i18n/`, '.json');
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    CalendarModule,
    MultiSelectModule,
    TabViewModule,
    DropdownModule,
    TableModule,
    DragDropModule,
    ChartModule,
    ButtonModule,
    CheckboxModule,
    InputNumberModule,
    PaginatorModule,
    OverlayPanelModule,
    AutoCompleteModule,
    TreeModule,
    TreeTableModule,
    ChipsModule,
    FileUploadModule,
    InputMaskModule,
    TranslateModule.forChild(),
    UIHelpersModule,
    EditorModule,
    NgxExtendedPdfViewerModule,
    NgxViewerModule,
  ],
  declarations: [
    ProductFormValidator,
    FilePreviewComponent,
  ],
  exports: [
    ReactiveFormsModule,
    ModalModule,
    ButtonModule,
    CalendarModule,
    MultiSelectModule,
    TabViewModule,
    DropdownModule,
    TableModule,
    DragDropModule,
    ChartModule,
    CheckboxModule,
    InputNumberModule,
    PaginatorModule,
    OverlayPanelModule,
    AutoCompleteModule,
    TreeModule,
    TreeTableModule,
    ChipsModule,
    TranslateModule,
    MenuModule,
    MenubarModule,
    FileUploadModule,
    TieredMenuModule,
    FileUploadModule,
    InputMaskModule,
    UIHelpersModule,
    EditorModule,
    NgxExtendedPdfViewerModule,
    NgxViewerModule,

    ProductFormValidator,
    FilePreviewComponent
  ],
  providers: [
    MessageService,
  ]
})
export class BMSSharedModule {

}
